import { registerDestructor } from '@ember/destroyable';
import Service, { service } from '@ember/service';

/**
 * Manages the client session lifecycle by opening and closing the websocket connection.
 */
export default class MessagingSessionService extends Service {
  @service('websocket/messagingWebsocket') messagingWebsocket;

  constructor() {
    super(...arguments);
    registerDestructor(this, () => this.stop());
  }

  start(messagingApiUrl) {
    this.messagingWebsocket.openSocket(messagingApiUrl);
    this.messagingWebsocket.subscribeToCurrentUserActiveConversation();
  }

  stop() {
    this.messagingWebsocket.closeSocket();
  }
}
